<template>
  <form @submit.prevent="validateBeforeSubmit">
    <b-field grouped>
      <b-field
        label="Título"
        expanded
        :type="{ 'is-danger': errors.has('title') }"
        :message="errors.first('title')"
        size="is-large"
      >
        <b-input
          v-model="data.title"
          name="title"
          maxlength="18"
          :has-counter="false"
          v-validate="'required'"
          data-vv-as="title"
        />
      </b-field>
    </b-field>

    <b-field grouped>
      <b-field :label="`Restrição diária`" expanded>
        <b-input
          placeholder="R$ 100,00"
          v-model="data.dailyAmount"
          @input="inputCurrencyMask($event, 'dailyAmount')"
        />
      </b-field>
      <b-field :label="`Restrição semanal`" expanded>
        <b-input
          placeholder="R$ 100,00"
          v-model="data.weeklyAmount"
          @input="inputCurrencyMask($event, 'weeklyAmount')"
        />
      </b-field>
      <b-field :label="`Restrição mensal`" expanded>
        <b-input
          placeholder="R$ 100,00"
          v-model="data.monthlyAmount"
          @input="inputCurrencyMask($event, 'monthlyAmount')"
        />
      </b-field>
    </b-field>

    <hr />
    <div class="buttons is-right">
      <router-link class="button is-rounded" :to="'/configuracoes'"
        >Voltar</router-link
      >
      <button
        class="button is-rounded is-primary"
        type="submit"
        @click.prevent="validateAndSubmit"
      >
        Salvar
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    data: Object
  },
  onMounted() {
    if (this.data) {
      this.data.dailyAmount = this.currencyMask(this.data.dailyAmount);
      this.data.weeklyAmount = this.currencyMask(this.data.weeklyAmount);
      this.data.monthlyAmount = this.currencyMask(this.data.monthlyAmount);
    }
  },
  methods: {
    currencyMask(value) {
      if(typeof value === 'number') {
        value = value.toString();
      }

      let rawValue = value.replace(".", "").replace(",", "").replace(/\D/g, "");

      if (rawValue.length === 0) {
        rawValue = "0,00";
      }

      const formattedValue = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
      }).format(parseFloat(rawValue) / 100);

      return `R$ ${formattedValue.trim()}`;
    },
    inputCurrencyMask(value, model) {
      this.data[model] = this.currencyMask(value);
    },
    validateAndSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("save", this.getRawData());
          return;
        }
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger"
        });
      });
    },
    getRawData() {
      try {
        const rawData = Object.assign({}, this.data);

        rawData.dailyAmount = this.getUnformattedNumber(rawData.dailyAmount);
        rawData.weeklyAmount = this.getUnformattedNumber(rawData.weeklyAmount);
        rawData.monthlyAmount = this.getUnformattedNumber(rawData.monthlyAmount);

        return rawData;
      } catch (error) {
        console.error('error when preparing data to submit.', error);
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger"
        });
      }
    },
    getUnformattedNumber(value) {
      if (value) {
      return parseFloat(
        value
          .replace("R$", "")
          .replace(/\s/g, "")
          .replace(".", "")
          .replace(",", ".")
      );
      }
    }
  }
};
</script>
